<template>
  <base-layout
    :readOnly="readOnly"
    :value="value"
    :label-width="labelWidth"
    :text-align="textAlign"
    :style-type="styleType"
    :is-require="isRequire"
    :label="label"
    :is-dipatch="isDipatch"
  >
    <el-autocomplete
      class="base-elAutocomplete"
      clearable
      slot="control"
      :disabled="disabled"
      custom-item="el-autocomplete-item-row"
      v-model="inputValue"
      :placeholder="placeholder"
      :fetch-suggestions="querySearchAsync"
      @select="handleSelect"
    ></el-autocomplete>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { syncGetSearch } from "./base-search-remote";
import { handleEmitValue, autocomplete } from "./../props-config";
import Vue from "vue";
Vue.component("el-autocomplete-item-row", {
  functional: true,
  render: function(h, ctx) {
    var item = ctx.props.item;
    return h("li", ctx.data, [
      h("span", { attrs: { style: "float: left" } }, [item.comment]),
      h("span", { attrs: { style: "float: right" } }, [item.code])
    ]);
  },
  props: {
    item: { type: Object, required: true }
  }
});
export default {
  name: "base-autocomplete",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        // console.log("set", val);
        if (this.isDipatch) {
          this.$store.dispatch("updateObject", {
            obj: this.dipatchObj,
            attr: this.dipatchAttr,
            val: val
          });
        } else {
          this.$emit("input", val);
        }
      }
    }
  },
  props: {
    ...autocomplete,
    apiName: {
      type: String,
      default: ""
    },
    selectFormat: {
      type: Function,
      default: function(item) {
        return item.code;
      }
    }
  },
  mounted() {},
  methods: {
    handleSelect(selectItem) {
      //   console.log("handleSelect", selectItem);
      if (!selectItem) return false;
      this.selectItem = selectItem;
      this.$emit("handleEmitValue", this.selectItem);
      this.$emit("handle-emit-value", this.selectItem);

      if (this.isDipatch) {
        this.$store.dispatch("updateObject", {
          obj: this.dipatchObj,
          attr: this.dipatchAttr,
          val: this.selectFormat(selectItem)
        });
      } else {
        this.$emit("input", selectItem.code);
      }
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) return false;
      setTimeout(() => {
        clearTimeout(this.timer);
        syncGetSearch(this.apiName, {
          ...this.params,
          query: queryString
        }).then(res => {
          this.getOptions = res;
          console.log(res);
          cb(res);
        });
      }, 1000);
    }
  },
  data() {
    return {
      timer: null,
      selectItem: null,
      getOptions: []
    };
  }
};
</script>

<style lang="scss">
.base-elAutocomplete {
  width: 100%;
  .el-autocomplete {
    width: 100%;
  }
}
</style>